import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private jsonContent = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': sessionStorage.getItem('batoken'),
      'User': sessionStorage.getItem('userid')
    })
  };


  constructor(
    private http: HttpClient,
    private configService: ConfigService) { }

  public listUsers(): Promise<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
    return this.http.get(`${this.configService.API_URL}/usuarios/listausuarios`, { headers }).toPromise();
  }

  public listUsuariosZonas(): Promise<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
    return this.http.get(`${this.configService.API_URL}/usuarios/listaUsuariosZonas`, { headers }).toPromise();
  }

  public update(user: any, userId: number): Promise<any> {
    return this.http.put(
      `${this.configService.API_URL}/usuarios/${userId}`,
      user,
      { ...this.jsonContent, responseType: 'text' }).toPromise();
  }

  public create(user: any): Promise<any> {
    return this.http.post(
      `${this.configService.API_URL}/usuarios`,
      user,
      { ...this.jsonContent, responseType: 'text' }).toPromise();
  }

  public delete(userId: number) : Promise<any> {
    return this.http.delete(
      `${this.configService.API_URL}/usuarios/${userId}`,
      { ...this.jsonContent, responseType: 'json' }).toPromise();
  }
}

